import { mapActions } from 'vuex';
import Events from '_utils/events';
import ProductService from '_services/rest/modules/product';
import { _OPEN_CONFIRMATION_ } from './ProductModel';

export default {
  name: 'product-action',
  data() {
    return {
      type: 'product',
      object: null,
      message: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    callback() {
      const { callback } = this.confirmation[this.type];
      this[callback]();
    },
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      ProductService.deleteProduct(this.object.id)
        .then(() => {
          this.close();
          this.$router.push('/admin/produtos/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Produto deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }));
    },
    deleteFile() {
      this.close();
      ProductService.deleteFile(this.object.id)
        .then(() => {
          this.model.images = this.model.images.filter(image => image.id !== this.object.id);
          this.activeAlert({ message: this.message, theme: 'success' });
        });
    },
  },
  mounted() {
    Events.$on(_OPEN_CONFIRMATION_, ({ object, type, message }) => {
      this.type = type;
      this.object = object;
      this.message = message;
      this.setToggle({ type: 'confirm_modal', bool: true });
    });
  },
};
